module.exports = __webpack_public_path__ + "static/media/fantasycoach_mrec_300x250@2x.f1b3f3d4.jpg";